// A printed section total must match the rows the document renders (O-4734).
// The settlement worksheet (settling + html) renders every row, so it prints
// the unfiltered total; every other render filters rows by show_in_offer
// (offer documents) or by settlement visibility (settlement PDFs — already
// mapped onto show_in_offer by applySettlementEdits), so it prints the
// engine's external (show_in_offer-filtered) total.
export const sectionDisplayTotal = (section, key, isSettling, requestFormat) => {
  if (isSettling && requestFormat === 'html') {
    return section[key];
  }

  return section[`external${key.charAt(0).toUpperCase()}${key.slice(1)}`];
};
